export const apiPathName = '/api/demo';
